import React, { Fragment, useEffect, useState } from "react";
import {
  ViedocButtonElement,
  ViedocDialogElement,
} from "../../../../secure/elements/ViedocReactElements";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import * as templateActions from "../../../../store/actions/templateActions";
import * as UtilsHelper from "../../../../../utils/utilsHelper";
import _ from "underscore";
import Loader from "../../shared/Loader/Loader";

const EditZoneSection = ({
  setIsEditZoneSectionVisible,
  artifactDetails,
  view,
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const { tmfStructureData, editError, isEditLoading } = useSelector(
    (store) => store.template
  );
  const { location, name, origid } = artifactDetails;

  const [zoneSectionName, setZoneSectionName] = useState(name);
  const isZone = location === "zones";
  const [isTouched, setIsTouched] = useState(false);
  const [showToaster, setShowToaster] = useState(false);
  const [initialLoad, setInitialLoad] = useState(true);

  useEffect(() => {
    name === zoneSectionName ? setIsTouched(false) : setIsTouched(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [zoneSectionName]);

  useEffect(() => {
    !_.isEmpty(editError) && setShowToaster(true);
    if (_.isEmpty(editError) && !isEditLoading && !initialLoad) {
      setIsEditZoneSectionVisible(false);
      setInitialLoad(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editError, isEditLoading]);

  const spanFunc = () => {
    return <span style={{ color: "#CC4E00" }}>*</span>;
  };

  const onHide = () => {
    setIsEditZoneSectionVisible(false);
    dispatch(templateActions.clearZoneError());
    setInitialLoad(false);
  };
  const saveChangesHandler = () => {
    let requestPayload = {};
    if (location === "zones") {
      requestPayload = {
        lastmodifiedon:
          artifactDetails?.lastmodifiedon || tmfStructureData?.lastmodifiedon,
        zoneId: origid,
        zoneName: zoneSectionName,
      };
      dispatch(templateActions.editZone(requestPayload));
    } else {
      requestPayload = {
        lastmodifiedon:
          artifactDetails?.lastmodifiedon || tmfStructureData?.lastmodifiedon,
        sectionId: origid,
        sectionName: zoneSectionName,
      };
      dispatch(templateActions.editSection(requestPayload));
    }
    setInitialLoad(false);
    setIsTouched(false);
  };

  const classificationArray = [
    {
      id: 1,
      label: `${
        isZone ? `${t("TMF.TEXT_ZONENO")}` : `${t("TMF.TEXT_SECTIONNO")}`
      }`,
      value: origid,
      class: "disabled_input",
      isDisabled: true,
      isRequired: false,
    },
    {
      id: 2,
      label: isZone
        ? t("DETAILPAGE.LABEL_ZONENAME")
        : t("TMF.TEXT_SECTIONNAME"),
      value: zoneSectionName,
      class: "disabled_input w-365",
      isDisabled: false,
      isRequired: true,
    },
  ];

  const nameChangeHandller = (event) => {
    setZoneSectionName(event.target.value);
    setIsTouched(true);
  };

  const getHeader = () => {
    switch (view) {
      case "view":
        return isZone
          ? `${t("ADMIN.TEXT_VIEW")} ${t("ADMIN.TEXT_ZONE")}`
          : `${t("ADMIN.TEXT_VIEW")} ${t("ADMIN.TEXT_SECTION")}`;
      case "edit":
        return isZone
          ? `${t("ADMIN.TEXT_EDIT")} ${t("ADMIN.TEXT_ZONE")}`
          : `${t("ADMIN.TEXT_EDIT")} ${t("ADMIN.TEXT_SECTION")}`;
      default:
        return null;
    }
  };

  const renderToaster = (message) => {
    return (
      showToaster &&
      editError !== "" && (
        <viedoc-toaster
          onClick={() => setShowToaster(false)}
          variant="error"
          prefix-icon="warning"
          toasterMsg={message}
        ></viedoc-toaster>
      )
    );
  };

  return (
    <ViedocDialogElement
      size="medium"
      open
      preventCloseByClick
      class="edit-artifact-popup"
      onHide={() => onHide()}
    >
      <header className="pl-10" slot="header">
        <p className="f21 mt-5">{getHeader()}</p>
        {!isEditLoading && (
          <div className="header-button">
            {view === "edit" && (
              <ViedocButtonElement
                size="small"
                variant="neutral"
                disabled={!isTouched}
                onClick={() => saveChangesHandler()}
                title={t("ADMIN.BUTTON_SAVEBTN")}
              >
                {t("ADMIN.BUTTON_SAVEBTN")}
              </ViedocButtonElement>
            )}
          </div>
        )}
      </header>
      {isEditLoading ? (
        <Loader width={"100%"} height={"100%"} borderRadius />
      ) : (
        <Fragment>
          {renderToaster(editError)}
          <div className="sub-header">
            <div className="icon-block">
              <viedoc-icon name="folder"></viedoc-icon>
              <p className="f24">{artifactDetails?.name}</p>
            </div>

            <p className="f14 gray-60 ml-70 ff-vmg">
              {`${t(
                "ADMIN.TEXT_FROMTEMPLATE"
              )} ${UtilsHelper.fileExtensionRemoval(
                tmfStructureData.templatename || ""
              )}`}
            </p>
          </div>
          <div className="bb-2 w-100"></div>
          <section className="view-artifact-block ff-vmg">
            <article className="sem-pri-color">
              {t("ADMIN.TEXT_CLASSIFICATIONLBL")}
            </article>
            <aside className="d-flex flex-dir-col">
              <div className="pt-10">
                {classificationArray.map((classification) => (
                  <div
                    className="d-flex pad-5 align-center"
                    key={classification.id}
                  >
                    <div className="w-25 text-right pr-15 gray-60 fw-400">
                      {classification.label}
                      {classification.isRequired ? spanFunc() : null}
                    </div>
                    {
                      <viedoc-textfield
                        class={classification.class}
                        size="small"
                        variant="outline"
                      >
                        <input
                          type="text"
                          disabled={
                            classification.isDisabled || view === "view"
                          }
                          value={classification.value}
                          onChange={(e) => nameChangeHandller(e)}
                        />
                      </viedoc-textfield>
                    }
                  </div>
                ))}
              </div>
            </aside>
          </section>
        </Fragment>
      )}
    </ViedocDialogElement>
  );
};

export default EditZoneSection;
